<template>
	<div>
		<p class="mb-3 mt-3 ml-5">{{ title }}</p>
		<div class="vx-col w-full md:w-1/1 lg:w-1/1 xl:w-1/1">
			<vx-card :cardBorder="false" :noShadow="true" v-show="featuresOpen">
				<div class="vx-row">
					<div class="vx-col md:w-1/2 w-full">
						<p class="mb-3">
							<code class="text-success">{{ $t("ManualData.InformationFound") }}</code>
						</p>
						<div v-for="(value, key) in local_data.register" :key="key">
							{{ key }}: {{ value }}
							<feather-icon
								:title="titleDeleteProperty"
								v-if="editMode"
								icon="XSquareIcon"
								svgClasses="w-5 h-5 hover:text-primary text-danger stroke-current"
								class="ml-2"
								@click.stop="removeProperties(key)"
							/>
							<feather-icon
								v-if="editMode"
								:title="titleUpdateProperty"
								icon="EditIcon"
								svgClasses="w-5 h-5 hover:text-success stroke-current"
								class="ml-2"
								@click.stop="editProperties(key, value)"
							/>
							<vs-divider class="d-theme-border-grey-light m-2" />
						</div>
					</div>
					<div class="vx-col md:w-1/2 w-full">
						<p class="mb-3">
							<code class="text-danger">{{ $t("ManualData.ErrorsFound") }}</code>
						</p>
						{{ findErrorNamePropertyValidator(local_data.validator) }} :
						{{ validateRequired(local_data.validator) }}
						<feather-icon
							v-if="editMode && local_data.validator.validator === 'required'"
							:title="titleAddProperty"
							icon="PlusSquareIcon"
							svgClasses="w-5 h-5 hover:text-primary text-success stroke-current"
							class="ml-2"
							@click.stop="addProperty(findErrorNamePropertyValidator(local_data.validator), index)"
						/>
						<vs-divider class="d-theme-border-grey-light m-2" />
					</div>
				</div>
			</vx-card>
		</div>
		<vs-prompt
			:title="$t('Information')"
			@cancel="cancelPrompt"
			@accept="acceptPrompt"
			@close="closePrompt"
			:active.sync="activePrompt"
			:acceptText="$t('Accept')"
			:cancelText="$t('Cancel')"
		>
			<div class="con-exemple-prompt">
				<p>{{ $t("ManualData.EditAlertText") }}</p>
				<div class="mt-4">
					<!-- USERNAME -->
					<vx-input-group class="mb-base">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span>{{ propertySelected }}</span>
							</div>
						</template>

						<vs-input v-model="propertyValue" />
					</vx-input-group>
					<!-- /USERNAME -->
				</div>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import moduleCommon from "@/store/common/moduleCommon.js";
import vSelect from "vue-select";

export default {
	props: {
		data: {
			type: Object,
		},
		edit: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		vSelect,
	},
	data() {
		return {
			featuresOpen: false,
			local_data: JSON.parse(JSON.stringify(this.data)),
			activePrompt: false,
			propertySelected: "",
			propertyValue: "",
			editMode: false,
		};
	},
	computed: {
		titleAddProperty() {
			return this.$t("Add") + " " + this.$t("ManualData.Property");
		},
		titleUpdateProperty() {
			return this.$t("Crud.Update") + " " + this.$t("ManualData.Property");
		},
		titleDeleteProperty() {
			return this.$t("Crud.Delete") + " " + this.$t("ManualData.Property");
		},
		title() {
			return this.data.register.identification ? this.data.register.identification : this.data.added_on;
		},
		nameProperty() {
			return function (key) {
				let name = this.$t(`ManualData.${key}`);
				if (name.split(".").length > 1) {
					return name.split(".")[1];
				} else {
					return name;
				}
			};
		},
		processErrorValidator() {
			return function (cadena) {
				const expresion = /'(.*)'/gm;
				const foundMatch = cadena.match(expresion);
				return foundMatch ? foundMatch[0].replace(/'/g, "") : cadena;
			};
		},
		findErrorNamePropertyValidator() {
			return function validator(value) {
				if (Array.isArray(value)) {
					return validator(value[0]);
				}
				const absolute_path = value.absolute_path[1];
				if (absolute_path === "additional_info") {
					let message = value.message;
					const expresion = /'(.*)'/gm;
					const foundMatch = message.match(expresion);
					if (value.absolute_path.length > 1) {
						return value.absolute_path[1];
					}
					return foundMatch ? foundMatch[0].replace(/'/g, "") : message;
				} else {
					return absolute_path;
				}
			};
		},
		validateRequired() {
			const vali = (value) => {
				switch (value.validator) {
					case "required":
					case "backend":
						return this.messageValidator(value.message);
					case "minLength":
						return this.$t("ManualData.TooShortProperties");
					case "additionalProperties":
						return this.$t("ManualData.ValidatorAdditionalProperties");
					default:
						return value.message;
				}
			};
			return vali;
		},
	},
	methods: {
		toggleFeatures() {
			this.featuresOpen = !this.featuresOpen;
		},
		changeEditMode() {
			this.editMode = !this.editMode;
			if (!this.featuresOpen) {
				this.featuresOpen = !this.featuresOpen;
			}
		},
		getData() {
			this.$emit("resolveManualDataEmit", this.local_data);
		},
		findText(searhStr, str) {
			return str.search(searhStr) != -1;
		},
		messageValidator(message) {
			const messageMap = {
				"Already registered": "ManualData.AlreadyRegistered",
				"Existing identification.": "ManualData.AlreadyRegistered",
				"Date less than current date": "ManualData.DateLessThanCurrentDate",
				"Not registered": "ManualData.NotRegistered",
				"is a required property": "ManualData.ValidatorRequiredProperty",
				"Init hour greater than end hour": "Schedule.ValidEndOur",
				"The address could not be georeferenced": "ManualData.AddressCouldBeNotGeoreferenced",
				"coordinates could not be found": "ManualData.CoordinatesCouldBeNotFound",
				error_date: "ManualData.ErrorDate",
				error_init_hour: "ManualData.ErrorInitHour",
				error_end_hour: "ManualData.ErrorEndHour",
				"Init hour less than current time": "ManualData.InitHourLessThanCurrentTime",
				"Duplicate record in excel": "ManualData.DuplicateRecordInExcel",
				"Dane code not found": "ManualData.DaneCodeNotFound",
				"Save record error": "ManualData.SaveRecordError",
				"Activity not available for the resource": "Schedule.ActivityNoAvailable",
				"Resource has no activities": "ManualData.ResourceHasNoActivities",
				"does not match": "Email",
				"time data": "ManualData.TimeDataFormat",
			};
			for (const [text, translationKey] of Object.entries(messageMap)) {
				if (this.findText(text, message)) {
					return this.$t(translationKey);
				}
			}
			return message;
		},
		addProperty(name, index) {
			this.local_data.validator.error.splice(index, 1);
			this.local_data.register[name] = "";
			this.propertySelected = name;
			this.activePrompt = true;
		},
		removeProperties(property) {
			delete this.local_data.register[property];
			const res = {...this.local_data.register};
			this.local_data.register = res;
		},
		editProperties(key, value) {
			this.propertySelected = key;
			this.propertyValue = value;
			this.activePrompt = true;
		},
		acceptPrompt() {
			this.local_data.register = {
				...this.local_data.register,
				[this.propertySelected]: this.propertyValue,
			};
		},
		cancelPrompt() {
			this.propertySelected = "";
			this.propertyValue = "";
		},
		closePrompt() {
			this.propertySelected = "";
			this.propertyValue = "";
		},
	},
	created() {
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
	},
};
</script>
